export const LANGUAGE_STORAGE_KEY = 'hc_language';

export type SupportedLanguage = 'en' | 'ar';

export const RTL_LANGUAGES = new Set<SupportedLanguage>(['ar']);

export function getStoredLanguage(): SupportedLanguage | null {
  try {
    const value = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (value === 'en' || value === 'ar') {
      return value;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function setStoredLanguage(language: string): void {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    /* ignore */
  }
}

export function resolveLanguage(
  gameSettingsLanguage?: string | null,
  previewLanguage?: string | null
): SupportedLanguage {
  const candidate =
    previewLanguage || gameSettingsLanguage || getStoredLanguage();
  if (candidate === 'ar') {
    return candidate;
  }
  return 'en';
}
